import { render } from "./ClientCargaMasivaProveedores.vue?vue&type=template&id=6b7d4c07&scoped=true"
import script from "./ClientCargaMasivaProveedores.vue?vue&type=script&lang=js"
export * from "./ClientCargaMasivaProveedores.vue?vue&type=script&lang=js"

import "./ClientCargaMasivaProveedores.vue?vue&type=style&index=0&id=6b7d4c07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7d4c07"]])

export default __exports__